import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import {Box, Button, Fade, Grid, MenuItem, Modal, Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, LinearProgress } from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from 'axios';
import * as React from "react";
import {Config} from '../../config/config';
import {Helpers} from '../../utils/helpers';
import {PopupMessage} from '../../utils/message';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';

const starDropdown = [
    {value: '', label: 'All'},
    {value: 0, label: <><StarIcon style={{color: 'gold'}} />x0</>},
    {value: 1, label: <><StarIcon style={{color: 'gold'}} />x1</>},
    {value: 2, label: <><StarIcon style={{color: 'gold'}} />x2</>},
    {value: 3, label: <><StarIcon style={{color: 'gold'}} />x3</>},
];

const victoryDropdown = [
    {value: '', label: 'All'},
    {value: 'true', label: 'Won 🏆'},
    {value: 'false', label: 'Lost 🏳️'},
];

const canRevengeDropdown = [
    {value: '', label: 'All'},
    {value: 'true', label: <CheckIcon style={{color: 'green'}} />},
    {value: 'false', label: <CloseIcon style={{color: 'red'}} />},
];

const favoriteDropdown = [
    {value: '', label: 'All'},
    {value: 'true', label: 'YES'},
    {value: 'false', label: 'NO'},
];

class PlayerBattleLogsMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            openLoot: false,
            userId: this.props.playerId,
            filter: {
                type: 'attack',
                opponentId: '',
                stars: '',
                percent: '',
                won: '',
                version: '',
                statVersion: '',
                id: '',
                limit: 10,
                offset: 0,
                canRevenge: '',
                favorite: '',
            },
            attackLog: [],
            defenseLog: [],
            totalAttack: 0,
            totalDefense: 0,
            lootData: [],
        }
    }

    componentDidMount(): void {
        this.onSearch();
    }

    onChangeFilter(key: string, value: any) {
        const {filter} = this.state;

        filter[key] = value;

        this.setState({filter});
    }

    handleChangeType = () => {
        const {filter} = this.state;

        filter.type = filter.type === 'attack' ? 'defense' : 'attack';

        this.setState({filter});
    }

    setLoading = (loading: boolean) => {
        this.setState({loading});
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    onSearch = async () => {
        const {filter} = this.state;
        this.setLoading(true);

        const url = `${Config.getInstance.apiUrl}/api/battle_logs/`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        let params = `userId=${this.state.userId}&`;

        // Loop through the filter and add to the params
        for (const key in filter) {
            if (filter[key]) {
                params += `${key}=${filter[key]}&`;
            }
        }

        // Remove the last & from params
        if (params.length > 0) {
            params = params.substring(0, params.length - 1);
        }

        const response = await axios.get(`${url}?${params}`, {headers});

        const success = response.data.success;

        this.setLoading(false);

        if (success) {
            const data = response.data;

            const {attackLog, defenseLog, totalAttack, totalDefense} = data;

            this.setState({attackLog, defenseLog, totalAttack, totalDefense});
        } else {
            PopupMessage.error(`Error: ${response.data.message}`)
        }
    }

    onClearFilter = () => {
        const {filter} = this.state;

        // filter.type = 'attack';
        filter.opponentId = '';
        filter.stars = '';
        filter.percent = '';
        filter.won = '';
        filter.version = '';
        filter.statVersion = '';
        filter.id = '';
        filter.limit = 10;
        filter.offset = 0;
        filter.canRevenge = '';

        this.setState({filter});
    }

    formatNumber(number) {
        // Format 1000000 to 1,000,000
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    renderFilter = () => {
        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const {filter} = this.state;
        const isChecked = filter.type === 'defense';

        return <Paper style={style} >

            🗡️
            <Switch
                checked={isChecked}
                onChange={this.handleChangeType}
                inputProps={{'aria-label': 'toggle attack/defense'}}
            />
            🛡️

            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={2}>
                        <TextField
                            label="Opponent ID..."
                            value={filter.attackerId}
                            onChange={(e) => this.onChangeFilter('opponentId', e.target.value)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item sm={1}>
                        <TextField
                            label="Stars..."
                            value={filter.stars}
                            onChange={(e) => this.onChangeFilter('stars', e.target.value)}
                            fullWidth
                            variant="outlined"
                            select
                        >
                            {starDropdown.map((item, index) => {
                                return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                            })}
                        </TextField>
                    </Grid>

                    <Grid item sm={1}>
                        <TextField
                            label="Result..."
                            value={filter.won}
                            onChange={(e) => this.onChangeFilter('won', e.target.value)}
                            fullWidth
                            variant="outlined"
                            select
                        >
                            {victoryDropdown.map((item, index) => {
                                return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                            })}
                        </TextField>
                    </Grid>

                    <Grid item sm={1.5}>
                        <TextField
                            label="Can Revenge..."
                            value={filter.canRevenge}
                            onChange={(e) => this.onChangeFilter('canRevenge', e.target.value)}
                            fullWidth
                            variant="outlined"
                            select
                        >
                            {canRevengeDropdown.map((item, index) => {
                                return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                            })}
                        </TextField>
                    </Grid>

                    <Grid item sm={1}>
                        <TextField
                            label="Percent..."
                            value={filter.percent}
                            onChange={(e) => this.onChangeFilter('percent', e.target.value)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item sm={2}>
                        <TextField
                            label="Version..."
                            value={filter.version}
                            onChange={(e) => this.onChangeFilter('version', e.target.value)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            label="Stat Version..."
                            value={filter.statVersion}
                            onChange={(e) => this.onChangeFilter('statVersion', e.target.value)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item sm={1}>
                        <TextField
                            label="Favorite..."
                            value={filter.favorite}
                            onChange={(e) => this.onChangeFilter('favorite', e.target.value)}
                            fullWidth
                            variant="outlined"
                            select
                        >
                            {favoriteDropdown.map((item, index) => {
                                return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <TextField
                            label="Limit..."
                            value={filter.limit}
                            onChange={(e) => this.onChangeFilter('limit', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid>
                    <Grid item sm={1}>
                        <TextField
                            label="Offset..."
                            value={filter.offset}
                            onChange={(e) => this.onChangeFilter('offset', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid>

                    <Grid item sm={1}>
                        <Button disableElevation fullWidth variant="contained" color="error" onClick={this.onClearFilter}>Clear</Button>
                    </Grid>

                    <Grid item sm={1}>
                        <Button disableElevation fullWidth variant="contained" color="primary" onClick={this.onSearch}>Search</Button>
                    </Grid>

                </Grid>
            </Grid>
        </Paper>
    }

    renderOpponent = (opponent: any, opponentId: string) => {
        const {name, squad} = opponent;

        return <Paper>
            <Grid container sm={12} spacing={1}>
                <Grid item container sm={10}>
                    <Grid item sm={12}>{name}</Grid>
                    <Grid item sm={12}>[{squad?.name || 'No Squad'}]</Grid>
                </Grid>
                <Grid item sm={2}>
                    <ContentCopyIcon
                        onClick={() => this.copyToClipboard(JSON.stringify({
                            id: opponentId,
                            name,
                            squad
                        }))}
                    />
                </Grid>
            </Grid>
        </Paper>
    }

    renderBattleResult = (battle: any) => {
        const type = this.state.filter.type;
        const isAttack = type === 'attack';
        const favorite = isAttack ? battle.attacker_favorite : battle.defender_favorite;

        const {stars, percent, won} = battle;

        return (
            <Paper>
                <StarIcon style={stars > 0 ? {color: 'gold'} : {}} />
                <StarIcon style={stars > 1 ? {color: 'gold'} : {}} />
                <StarIcon style={stars > 2 ? {color: 'gold'} : {}} />
                <Typography>{percent}%</Typography>
                <Typography variant='h5'><span style={won ? {color: "gold"} : {color: "grey"}}>{won ? "Victory 🏆" : "Defeated 🏳️"}</span></Typography>
                <FavoriteIcon style={favorite ? {color: 'red'} : {}} />
            </Paper>
        );
    }

    renderVersions = (battle: any) => {
        const {version, stat_version} = battle;

        return <Grid container sm={12}>
            <Grid item container sm={8}>
                <Paper>
                    <Typography>{`V: ${version}`}</Typography>
                    <Typography>{`S: ${stat_version}`}</Typography>
                </Paper>
            </Grid>
            <Grid item container sm={2}>
                <ContentCopyIcon
                    onClick={() => this.copyToClipboard(JSON.stringify({version, stat_version}))}
                />
            </Grid>
        </Grid>
    }

    renderBattleLogs = () => {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }
        const {filter} = this.state;
        const type = filter.type;

        const isAttack = type === 'attack';
        const battles = isAttack ? this.state.attackLog : this.state.defenseLog;

        return <Paper>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={{width: "5%"}}>#</TableCell>
                        <TableCell style={{width: "5%"}}>ID</TableCell>
                        <TableCell style={{width: "17%"}}>{isAttack ? "Defender" : "Attacker"}</TableCell>
                        <TableCell style={{width: "5%"}}>Loot</TableCell>
                        <TableCell style={{width: "5%"}}>Gold</TableCell>
                        <TableCell style={{width: "5%"}}>Oil</TableCell>
                        <TableCell style={{width: "10%"}}>Versions</TableCell>
                        <TableCell>Revenge</TableCell>
                        <TableCell>Units</TableCell>
                        <TableCell>Result</TableCell>
                        <TableCell>Time</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {battles.map((battle: any, index: number) => {
                        this.renderBattleResult(battle);

                        const opponent = isAttack ? battle.defender : battle.attacker;
                        const opponentId = isAttack ? battle.defender_id : battle.attacker_id;
                        const lootDirection = isAttack ? 1 : -1;
                        const date = new Date(battle.created_at);

                        return <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{battle.id}</TableCell>
                            <TableCell>{this.renderOpponent(opponent, opponentId)}</TableCell>
                            <TableCell><Button onClick={() => this.selectBattleLoot(battle)} startIcon={<AssignmentOutlinedIcon style={{color: 'white'}}/>}></Button></TableCell>
                            <TableCell>{this.formatNumber(battle.cash * lootDirection)}</TableCell>
                            <TableCell>{this.formatNumber(battle.energy * lootDirection)}</TableCell>
                            <TableCell>{this.renderVersions(battle)}</TableCell>
                            <TableCell>{battle.can_revenge ? <CheckIcon style={{color: 'green'}} /> : <CloseIcon style={{color: 'red'}} />}</TableCell>
                            <TableCell>{this.renderUnits(battle.units)}</TableCell>
                            <TableCell>{this.renderBattleResult(battle)}</TableCell>
                            <TableCell>{date.toLocaleString('en-GB')}</TableCell>
                            <TableCell>
                                <ContentCopyIcon
                                    onClick={() => this.copyToClipboard(JSON.stringify(battle))}
                                />
                            </TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </Paper>
    }

    

    selectBattleLoot = (battle: any) => {
        console.log('battle ==== ', battle);
        this.setState({ battle, openLoot: true });
    }


    renderUnits = (units: any) => {
        const {artillery, followers, heroes} = units;
        const unitList = [...artillery, ...followers, ...heroes];

        return unitList.map((unit: any, index: number) => {
            const {id, amount, level} = unit;
            return (
                <Typography key={index}>
                    {`${id} x ${amount || 1} Lvl ${level}`}
                </Typography>
            );
        });
    }

    render() {
        const {classes} = this.props;
        const {filter} = this.state;
        
        const lootUserId = filter.type === 'attack' ? this.state.userId : this.state.battle?.attacker_id;
        return (
            <Paper className={classes.paper} elevation={0}>
                <Typography className={classes.paper} variant="h6">{`Battle log for UID: ${this.state.userId}`}</Typography>
                {this.renderFilter()}

                {this.renderBattleLogs()}
                {this.state.openLoot && <BattleLoot openLoot={this.state.openLoot} battle={this.state.battle} userId={lootUserId} onClose={() => this.setState({openLoot: false})}/>}
            </Paper>
        )
    }
}

const styles: any = () => ({
    paper: {
        padding: 8,
        backgroundColor: "black"
    },
});

class BattleLoot extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            openLoot: props.openLoot,
            lootData: [],
        }
    }

    componentDidMount(): void {
        this.getBattleLoot();
    }

    getObjectName(id: any, buildings: any = []) {
        try {
            const object = buildings.find(_object => _object.uniqueId === id);

            if (!object) {
                return id;
            }
            return `${this.getBuildingName(object.id)} - ${object.id} (${id})`;
        }
        catch(e) {
            console.error(e);
        }
    }

    getBuildingName(elementId) {
        return this.getTranslation(`building_${elementId}name`);
    }

    getTranslation(key: string) {
        const translation = JSON.parse(localStorage.getItem("LOCALIZATION") || '{}').find(item => item.key === key);
        if (!translation) {
            return key;
        }
        return translation.value;
    }

    getBattleLoot = async () => {
        // console.log('+++++ get loot called === ', this.props.userId, this.props.battle)
        if (!this.props.userId || !this.props.battle) return [];

        this.setState({ loading: true });
        const url = `${Config.getInstance.apiUrl}/api/battle_logs/loot`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        let params = `userId=${this.props.userId}&battleId=${this.props.battle.id}`;

        const response = await axios.get(`${url}?${params}`, {headers});
        const success = response.data.success;
        // console.log('+++++ get loot response ==== ', response)
        this.setState({ loading: false });
        if (success) {
            const data = response.data;

            const { data:
                {
                    meta: { methodRequest: { lootData } },
                    data: {village: {buildings}}
                }
            } = data;
            if (buildings && lootData) {
                lootData.forEach((loot: any) => {
                    loot.name = this.getObjectName(loot.id, buildings);
                });
            }
            this.setState({lootData: lootData});
        }
        this.setState({openLoot: true});
    }

    render(): React.ReactNode {
        const { loading, lootData } = this.state;
        return (<Modal
            title="Loot"
            open={this.state.openLoot}
            onClose={() => {
                this.setState({ openLoot: false, lootData: [] });
                this.props.onClose && this.props.onClose();
            }}
            >
            <Fade in={this.state.openLoot}>
                <Box sx={{
                position: 'absolute' as 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 'auto',
                maxHeight: '50vh',
                overflowY: 'auto',
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Loot Data
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Damage</TableCell>
                                <TableCell>Oil</TableCell>
                                <TableCell>Gold</TableCell>
                            </TableRow>

                        </TableHead>
                        <TableBody>
                            {!loading && lootData.map((row: any, index: number) => {
                                return <TableRow>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.damage || 0}</TableCell>
                                    <TableCell>{row.crystals || 0}</TableCell>
                                    <TableCell>{row.honey || 0}</TableCell>
                                </TableRow>
                            })}
                        </TableBody>
                    </Table>
                    {loading && <LinearProgress />}
                </Box>
            </Fade>
        </Modal>)
    }
}

export const PlayerBattleLogs = withStyles(styles)(PlayerBattleLogsMain);